import MachineUsageHead from "./MachineUsageHead";
export default MachineUsageHead;